//local
// const BASE_URL = `http://192.168.0.110/Alabaster-Backend/public/api/`;
// export const IMG_URL = `http://192.168.0.110/Alabaster-Backend/public/storage/uploads/`;

//live
const BASE_URL = `https://alabastermobileapp.com/api/`;
export const IMG_URL = `https://alabastermobileapp.com/storage/uploads/`;


export const GOOGLE_MAPS_APIKEY = 'AIzaSyD3NUxL1BZ3S4v69vZExUtXdbFRAQEiMcE';


//staging
// const BASE_URL = `https://appdevprojects.co/Alabaster-Backend/public/api/`;
// export const IMG_URL = `https://appdevprojects.co/Alabaster-Backend/public/storage/uploads/`;

const Apis = {
  //Auth
  login: `${BASE_URL}login`,
  updateOnlineStatus: `${BASE_URL}updateOnlineStatus`,
  signup: `${BASE_URL}signup`,
  forgot_password: `${BASE_URL}forgot_password`,
  change_password: `${BASE_URL}change_password`,
  updatePassword: `${BASE_URL}updatePassword`,
  logout: `${BASE_URL}logout`,

  //App
  categories: `${BASE_URL}categories`,
  cleaners: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}cleaners`,
  customers: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}customers`,
  customersCreate: `${BASE_URL}customersCreate`,
  jobs: next_page_url => (next_page_url ? next_page_url : `${BASE_URL}jobs`),
  jobsCreate: `${BASE_URL}jobsCreate`,
  getSubscriptionHistory: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}getSubscriptionHistory`,
  cleanersCreate: `${BASE_URL}cleanersCreate`,
  cleanersUpdate: `${BASE_URL}cleanersUpdate`,
  activeCleaners: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}activeCleaners`,
  stores: `${BASE_URL}stores`,
  inventories: `${BASE_URL}inventories`,
  workRequestCustomers: `${BASE_URL}workRequestCustomers`,
  workRequests: `${BASE_URL}workRequests/`,
  declineWorkRequest: `${BASE_URL}declineWorkRequest`,
  contactQuery: `${BASE_URL}contactQuery`,
  pages: `${BASE_URL}pages`,

  getUsersByRole: `${BASE_URL}getUsersByRole`,
  getUserInfo: `${BASE_URL}getUserInfo`,
  getSubscriptionPackages: `${BASE_URL}getSubscriptionPackages`,
  updateProfile: `${BASE_URL}updateProfile`,
  deleteAddress: `${BASE_URL}deleteAddress`,
  showCards: `${BASE_URL}showCards`,
  storeCard: `${BASE_URL}storeCard`,
  deleteCard: `${BASE_URL}deleteCard`,
  updateDefaultCard: `${BASE_URL}updateDefaultCard/`,
  checklist: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}checklist`,
  memberslist: `${BASE_URL}viewMembersList`,
  members: `${BASE_URL}getUsers`,
  addmembers: `${BASE_URL}storeMember`,
  getUserNotificaions: `${BASE_URL}getUserNotifications`,
  sendChecklist: `${BASE_URL}sendChecklist/`,
  // getJobsByCleanerId: `${BASE_URL}getJobsByCleanerId`,
  checklistCreate: `${BASE_URL}checklistCreate`,
  chatIndex: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}chatIndex`,
  viewChatlist: (next_page_url, id) =>
    next_page_url ? next_page_url : `${BASE_URL}viewChatlist/${id}`,
  chatlistCheck: `${BASE_URL}chatlistCheck`,
  sendMessage: `${BASE_URL}sendMessage`,
  assignJobToCleaner: `${BASE_URL}assignJobToCleaner`,
  getJobsByCleanerId: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}getJobsByCleanerId`,
  getActiveLocations: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}getActiveLocations`,
  contractorDashboard: `${BASE_URL}contractorDashboard`,
  jobDetail: `${BASE_URL}jobDetail/`,
  workRequestsCreate: `${BASE_URL}workRequestsCreate`,
  specificjobs: `${BASE_URL}jobs`,
  startJob: `${BASE_URL}startJob`,
  breakIn: `${BASE_URL}breakIn`,
  breakOut: `${BASE_URL}breakOut`,
  jobComplete: `${BASE_URL}jobComplete`,
  timeSheet: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}timeSheet`,
  cleanerDashboard: `${BASE_URL}cleanerDashboard`,
  problemReporting: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}problemReporting`,
  updateInventoryStatus: `${BASE_URL}updateInventoryStatus`,
  customerDashboard: `${BASE_URL}customerDashboard`,
  checklistReports: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}checklistReports`,
  weeklyInspections: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}weeklyInspections`,
  completedJobsLocations: `${BASE_URL}completedJobsLocations`,
  cleanersJobsLocations: `${BASE_URL}completedJobsLocations`,
  updateChecklistRemark: `${BASE_URL}updateChecklistRemark`,
  updateNotificationSetting: `${BASE_URL}updateNotificationSetting`,
  updateChecklist: `${BASE_URL}updateChecklist`,
  deleteChecklist: `${BASE_URL}deleteChecklist`,
  contractorComment: `${BASE_URL}contractorComment`,
  sendJobReportToCustomer: `${BASE_URL}sendJobReportToCustomer`,
  getCustomerActiveJobs: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}getCustomerActiveJobs`,
  updateGetStartedStatus: `${BASE_URL}updateGetStartedStatus`,
  deleteChecklist: `${BASE_URL}deleteChecklist`,
  subscribe: `${BASE_URL}subscribe`,
  subscribeInApp: `${BASE_URL}inAppSubscribe`,
  deleteAccount: `${BASE_URL}deleteAccount`,
  companies_list: `${BASE_URL}companies_list`,
  companies: next_page_url =>
    next_page_url ? next_page_url : `${BASE_URL}companies`,
  createCompany: `${BASE_URL}createCompany`,
  updateCompany: `${BASE_URL}updateCompany`,
};

export default Apis;
